<template>
  <div class="align-right chat-header__icon-container">
    <span
      v-tooltip="$t('chat.mark-favorite')"
      v-if="enableFavorite && agentID"
      class="chat-header__icon"
      :class="{ disabled: (blocked || blockFavorite) }"
      @click="
        toggleAnimation();
        confirmFavorite();
      "
    >
      <like
        class="icon"
        :class="{
          disabled: blocked,
          red: favorite,
          shake: animated && clicked,
          'shake-it-off': !animated && clicked,
        }"
      />
    </span>
    <span
      v-tooltip="$t('chat.block-client')"
      v-if="enableBlock && agentID"
      class="chat-header__icon"
      :class="{ 'chat-header__icon--block': clickBlock, blocked: blocked }"
      @click="
        confirmBlock();
        toggleBlock();
      "
    >
      <chat-block />
    </span>
    <hcc-confirmation />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import chatBlock from '@/assets/icons/chat-block.svg';
import like from '@/assets/icons/like.svg';
import actionsChat from '@/graphql/mutations/actionsChat.gql';
import HccConfirmation from '@/components/shared/HccConfirmation/index.vue';
import errorHandler from '@/utils/error.handler';

export default {
  components: {
    HccConfirmation,
    chatBlock,
    like,
  },
  props: {
    favorite: {
      required: true,
      type: Boolean,
    },
    channelID: {
      required: true,
      type: String,
    },
    client: {
      required: true,
      type: Object,
    },
    campaignID: {
      required: true,
      type: String,
    },
    agentID: {
      required: true,
      type: [String, null],
    },
    blocked: {
      required: true,
      type: Boolean,
    },
    enableFavorite: {
      required: true,
      type: Boolean,
      default: false,
    },
    enableBlock: {
      required: true,
      type: Boolean,
      default: false,
    },
    blockFavorite: {
      required: true,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      animated: false,
      clicked: false,
      clickBlock: false,
    };
  },
  methods: {
    ...mapMutations(['setFavoriteUser', 'setBlockedUser', 'addClientBlocked']),
    confirmBlock() {
      this.$modal.show('confirmation', {
        title: this.$t('dialog.title'),
        description: this.$t('dialog.description', { user: this.client.name }),
        variant: 'info',
        confirm: () => {
          this.actionChatUser({
            action: 'BLOCKUSER',
            client: this.client.id,
            campaign: this.campaignID,
            channel: this.channelID,
          })
            .then(() => {
              this.$toasted.global.success(this.$t('dialog.block-success', { user: this.client.name }));
              this.toggleBlock();
              const info = {
                client: this.client.id,
                idAgent: this.agentID,
                campaign: this.campaignID,
                channel: this.channelID,
              };
              this.addClientBlocked(info);
            })
            .catch((err) => {
              errorHandler.logErrors(err);
              this.$toasted.global.error(`Error: ${err}`);
            });
        },
        cancel: () => this.toggleBlock(),
      });
    },
    confirmFavorite() {
      this.actionChatUser({
        action: 'FAVORITE',
        client: this.client.id,
        campaign: this.campaignID,
        channel: this.channelID,
      })
        .then(() => {
          this.setFavoriteUser({
            agentID: this.agentID,
            campaignID: this.campaignID,
            channel: this.channelID,
          });
        })
        .catch((err) => {
          this.animated = this.favorite;
          errorHandler.logErrors(err);
          this.$toasted.global.error(`Error: ${err}`);
        });
    },
    actionChatUser(request) {
      return this.$apollo.mutate({
        mutation: actionsChat,
        variables: request,
      });
    },
    toggleAnimation() {
      if (this.animated !== !this.favorite) {
        this.animated = !this.favorite;
        this.clicked = true;
        this.$emit('click');
      }
    },
    toggleBlock() {
      this.clickBlock = !this.clickBlock;
    },
  },

};
</script>

<style lang="scss" scoped>
@import "~styles/components/actions-chat.scss";
</style>
